import { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/core/helpers/cn";

type Props = {
  children: ReactNode;
} & HTMLAttributes<HTMLDivElement>;

export default function PlayerMenuCharacterDataCard({ children, className, ...props }: Props) {
  return (
    <div
      className={cn(
        "w-[20.5rem] h-[13.5rem] rounded-[1rem] overflow-clip bg-dark-800 p-7.5 shrink-0",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
